// extracted by mini-css-extract-plugin
module.exports = {"cardinfo":"page_cardinfo__XOtIf","row-item":"page_row-item__tYJ0t","bgicon":"page_bgicon__7CiiA","icon":"page_icon__w89n3"};